import {Spinner} from '@sail/ui';
import {ScreenWrapper} from 'src/components/core/ScreenWrapper';

const Loading = () => (
  <ScreenWrapper alwaysCentered>
    <Spinner css={{width: 'large', height: 'large'}} data-testid="spinner" />
  </ScreenWrapper>
);

export default Loading;
